import LinearGradient from "@/assets/svg/vvv/linear-gradient.svg";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Link } from "react-router-dom";
import VVVPrimaryButton from "../design-system/vvv/Button";

export default function VVVCTA() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div ref={ref} className="relative">
      <img
        src={LinearGradient}
        className="absolute min-w-full top-1/2 -translate-y-1/2"
        alt="Gradient Background"
      />

      <div className="flex flex-col items-center text-center gap-8 justify-center h-screen 4xl:max-w-[100rem] 4xl:mx-auto">
        <p className="text-white/50">Media/Enterprise</p>

        <h1
          className={`
          vvv-font text-3xl md:text-5xl lg:text-6xl max-w-sm md:max-w-3xl
          ${!isVisible ? "hidden-start" : "h1-anim"}
        `}
          style={{ lineHeight: "1.4" }}
        >
          Scaleable media/
          <br className="lg:hidden" />
          TV <span className="text-primary">licensing</span> solutions
        </h1>

        <p
          className={`
          text-white max-w-xs md:max-w-2xl text-base md:text-lg
          ${!isVisible ? "hidden-start" : "p-anim"}
        `}
        >
          We’ve handpicked the internet’s funniest, most engaging, and most
          shareable videos primed for worldwide exposure.
        </p>

        <Link
          to={"/contact-us"}
          className={`${!isVisible ? "hidden-start" : "btn-anim"}`}
        >
          <VVVPrimaryButton name="Get VVV Enterprise" />
        </Link>
      </div>
    </div>
  );
}
